export enum WhatsAppIntegrationStatus {
  NOT_CONNECTED = "NOT_CONNECTED",
  PENDING = "PENDING",
  ACTIVE = "ACTIVE"
}
